export class NotificationDetailsSession {
    public aditionalEmails: AditionalEmail[] = [];
    public notifyMe: boolean = false;
    public showStatusBar: boolean = true;
}

export class AditionalEmail {
    public email: string = '';
    public countryLanguage: string = '';
    public validEmail: boolean = false;
    public emailFlag: boolean = false;
}